export default __webpack_public_path__ + "static/media/likeBlack.ecc8d55c.svg";